import { render, staticRenderFns } from "./CateringBotPrompt.vue?vue&type=template&id=41072dce&scoped=true"
import script from "./CateringBotPrompt.vue?vue&type=script&lang=ts"
export * from "./CateringBotPrompt.vue?vue&type=script&lang=ts"
import style0 from "./CateringBotPrompt.vue?vue&type=style&index=0&id=41072dce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41072dce",
  null
  
)

export default component.exports